import { Component, Input, OnInit } from '@angular/core';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { SiteContentModel } from 'src/app/models/site-content.model';
import { SiteContentService } from 'src/app/services/site-content.service';

@Component({
  selector: 'app-apg-quick-quote-summary',
  templateUrl: './apg-quick-quote-summary.component.html',
  styleUrls: ['./apg-quick-quote-summary.component.scss'],
})
export class ApgQuickQuoteSummaryComponent implements OnInit {
  @Input() quickQuote: QQQuestionnaireViewModel;
  question: QQQuestionViewModel;
  answers: any;
  disclaimer: SiteContentModel;
  sumAssuredLabel: string;

  constructor(
    private siteContentService: SiteContentService
  ) { }

  async ngOnInit() {
    //if (this.quickQuote.answersObject["Source"] !== 'CoverCalculator')
    this.answers = this.quickQuote.answersObject;
    this.question = this.quickQuote.currentPage.questions[0];

    this.disclaimer = await this.siteContentService.getSiteContent("QuickQuote.Disclaimer");
    await this.setSumAssuredLabel();
  } 

  async setSumAssuredLabel() {       
    const ans = (key: string) => this.quickQuote.answersObject[key] || '';
    const inclCi = ans('PolicyType_2');
    this.sumAssuredLabel = "Life Cover of";
    if (inclCi == 'TERM-CI') {
      this.sumAssuredLabel = "Life with Multi-Claim Critical Illness Cover of" ;
    }
  }
}
